import { toApiError } from '../services/apiClient';

export const COURT_CONFLICT_USER_MESSAGE =
  'Those courts are already booked for the selected time. Choose a different time or release the conflicting booking first.';

export function isCourtConflictError(error: unknown): boolean {
  const apiError = toApiError(error);
  return (
    apiError.code === 'COURT_CONFLICT' ||
    apiError.message.toLowerCase().includes('court schedule conflict')
  );
}

export function formatSchedulingErrorMessage(error: unknown, fallback: string): string {
  if (isCourtConflictError(error)) {
    return COURT_CONFLICT_USER_MESSAGE;
  }
  return toApiError(error).message || fallback;
}
